export default __webpack_public_path__ + "static/excelencia-pattern-nogradient-0e03adb7f51bfba2aea358b027d11d85.png";